import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Sobre from "../pages/sobre/page";
import Servicos from "../pages/servicos/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sobre",
    element: <Sobre />,
  },
  {
    path: "/servicos",
    element: <Servicos />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
